import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TransferInterface } from '../data';
import { TransferProvider } from '../providers/transfer-provider.service';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface SetTransferUseCaseParams {
    transfer: TransferInterface;
}

@Injectable()
export class SetTransferUseCase implements UseCaseWithParam<SetTransferUseCaseParams, Observable<Transaction<boolean>>> {
    constructor(private transferProvider: TransferProvider) {}

    bind(params: SetTransferUseCaseParams): Observable<Transaction<boolean>> {
        return this.transferProvider.setTransfer(params.transfer);
    }
}
